module.exports = __webpack_public_path__ + "static/media/CV_TiagoMartinho.4833470c.pdf";